import { useState } from 'react'
import styled, { css } from 'styled-components'
import { fontWeights, colors } from '@/styles'
import ArrowDownIcon from './arrow-down.svg?react'

const rotate = ({ isOpen }: { isOpen: boolean }) => (isOpen ? '0deg' : '180deg')

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`
const Header = styled.div<{ smallBorder: boolean }>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  cursor: pointer;
  padding: 12px;
  background: ${colors.grey96};
  border-bottom: ${props =>
    props.smallBorder ? `1px solid ${colors.grey88}` : `2px solid ${colors.grey80}`};
`
const StyledArrowDownIcon = styled(ArrowDownIcon)<{ isOpen: boolean }>`
  -webkit-transform: rotate(${rotate});
  -moz-transform: rotate(${rotate});
  -ms-transform: rotate(${rotate});
  -o-transform: rotate(${rotate});
  transform: rotate(${rotate});
`
const defaultStyle = css`
  font-weight: ${fontWeights.mediumBold};
  font-size: 16px;
  line-height: 24px;
`

const small = css`
  font-weight: ${fontWeights.medium};
  font-size: 14px;
  line-height: 20px;
`

const getTextStyle = (textStyle?: string) => {
  if (textStyle === 'small') return small

  return defaultStyle
}

const HeaderText = styled.p<{ textStyle: string; isLocked: boolean }>`
  ${props => getTextStyle(props.textStyle)}
  ${props =>
    props.isLocked &&
    `
    filter: blur(10px);
    color: ${colors.black};
    background-color: ${colors.grey96};
    -webkit-touch-callout: none;
    -webkit-user-select: none; 
    -khtml-user-select: none; 
    -moz-user-select: none; 
    -ms-user-select: none; 
    user-select: none; 
    cursor: not-allowed;
  `}
  margin: 0;
`

type CollapsibleContainerProps = {
  children?: React.ReactNode
  title?: string | React.ReactNode
  defaultOpen: boolean
  smallBorder?: boolean
  showToggle?: boolean
  textStyle?: string
  isLocked?: boolean
}

const CollapsibleContainer: React.FC<CollapsibleContainerProps> = ({
  title = '',
  defaultOpen,
  smallBorder = false,
  showToggle = true,
  textStyle = 'default',
  isLocked = false,
  children
}) => {
  const randomWords = '***** ******** *****'
  const [isOpen, setIsOpen] = useState(defaultOpen)
  const toggleIsOpen = () => {
    if (showToggle) setIsOpen(state => !state)
  }
  const text = isLocked ? randomWords : title
  return (
    <Wrapper>
      <Header onClick={toggleIsOpen} smallBorder={smallBorder}>
        <HeaderText textStyle={textStyle} isLocked={isLocked}>
          {text}
        </HeaderText>
        {showToggle && <StyledArrowDownIcon isOpen={isOpen} />}
      </Header>
      {isOpen && children}
    </Wrapper>
  )
}

export default CollapsibleContainer
